import {
    COURSE_NAME_TO_COURSE_URL_MAPPING,
    COURSE_URL_TO_DASHBOARD_COURSE_IDENTIFIER_MAPPING,
    UNIVERSITY_FRONTEND_AUTH_URL,
    UNIVERSITY_FRONTEND_DASHBOARD_URL,
} from "../Constants/ReRoutingConstants";

export const openUniversityLoginPageWithPrefilledEmail = ({ email, collegeId }) => {
    const query = `step=login&email=${email}&univ=${collegeId}`;
    const URL = `${UNIVERSITY_FRONTEND_AUTH_URL}?${query}`;
    window.open(URL, "_self");
};

export const openUniversityDashboard = () => {
    window.open(UNIVERSITY_FRONTEND_DASHBOARD_URL, "_self");
};

export const redirectToDashboardWithCorrectCourseHighlighted = (url) => {
    // Find the matching course URL from constants
    const matchedCourseUrl = Object.values(COURSE_NAME_TO_COURSE_URL_MAPPING).find((courseUrl) =>
        url.includes(courseUrl),
    );

    // If no match found, do nothing
    if (!matchedCourseUrl) return;

    // Get the dashboard identifier from mapping
    const courseIdentifier = COURSE_URL_TO_DASHBOARD_COURSE_IDENTIFIER_MAPPING[matchedCourseUrl];

    // Redirect to dashboard with correct course highlighted
    if (courseIdentifier) {
        window.open(
            `${process.env.REACT_APP_NEW_DASHBOARD_URL}/?course=${courseIdentifier}`,
            "_self",
        );
    } else {
        window.open(`${process.env.REACT_APP_NEW_DASHBOARD_URL}`, "_self");
    }
};
